import * as store2 from 'store2';

const BASE_NAMESPACE = 'KT_APP';
const localStorage = store2.local.namespace(BASE_NAMESPACE);

export function getLocalStorage(key: string): any {
  return localStorage.get(key);
}

export function setLocalStorage(key: string, data: any = ''): any {
  return localStorage.set(key, data);
}

export function setValueInNamespace(key: string, data: any, namespace: string): void {
  localStorage.namespace(namespace).set(key, data);
}

export function getValueFromNamespace(key: string, namespace: string): any {
  return localStorage.namespace(namespace).get(key);
}
